import React from 'react';
import PersonalizedDiscovery from '../components/personalization/PersonalizedDiscovery';

/**
 * DiscoverPage - Feature-flagged page aggregating all 4 personalized sections
 * Route: /discover
 */
export default function DiscoverPage({ onItemClick }) {
  return (
    <div className="container mx-auto px-4 py-8">
      <PersonalizedDiscovery onItemClick={onItemClick} />
    </div>
  );
}

